import React from 'react';
import { CURRENCY_USD } from 'constants/currency';
import { OrderTotal } from 'utils/shared/money/calculateEventOrderTotal';
import { convertUnitPriceToFormattedPrice } from 'utils/shared/money/convertUnitPriceToFormattedPrice';
import { pluralize } from 'utils/shared/pluralize';
import Header from './Header';

export default function OrderConfirmationList({ orderTotal }: { orderTotal: OrderTotal }) {
  return (
    <>
      <Header title="Register" cta="Confirmation" className="px-6 pt-6" />
      <div className="mt-2 space-y-4 rounded-lg border border-color-brand-primary bg-color-bg-lightmode-brand-secondary p-ds-lg dark:bg-color-bg-darkmode-brand-secondary">
        {(orderTotal.registrationGroups || []).map((group, index) =>
          !group.priceUnitAmount ? null : (
            <div
              key={group.id}
              className="typography-product-body-highlight flex items-center justify-between"
            >
              <div>
                {group.sessionCount > 1
                  ? `${group.title} · ${pluralize({ count: group.sessionCount, singular: 'session' })}`
                  : `Event: ${group.title}`}
              </div>
              <div>
                {convertUnitPriceToFormattedPrice(group.priceUnitAmount, CURRENCY_USD).priceDisplay}
              </div>
            </div>
          ),
        )}

        {orderTotal.registrationGroups.map((group, index) => {
          return (
            <>
              <div className="flex flex-row gap-10">
                <h2 className="typography-product-body-highlight text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
                  {group.sessionCount > 1
                    ? pluralize({ count: group.sessionCount, singular: 'session' })
                    : `Event #${index + 1}`}
                </h2>
                <div className="flex items-center">
                  <p className="typography-product-body-highlight text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
                    {group.title}
                  </p>
                </div>
              </div>
            </>
          );
        })}
      </div>
    </>
  );
}
